import PropTypes from 'prop-types';
import useGTM from './useGTM';
import useGoogleAnalytics from './useGoogleAnalytics';

// Need this to be a component so we can code split with dynamic imports
export default function Tracking({
  grades = [],
  subjects = [],
  contentType = null,
  pageType = null,
  isInteractive = null,
}) {
  // Tracking Scripts
  useGoogleAnalytics(grades, subjects, contentType, pageType, isInteractive);
  useGTM(grades, subjects, contentType, pageType, isInteractive);

  return null;
}

Tracking.propTypes = {
  grades: PropTypes.arrayOf(PropTypes.string),
  subjects: PropTypes.arrayOf(PropTypes.string),
  contentType: PropTypes.string,
  pageType: PropTypes.string,
};
